import { Button, Card } from "src/components/ui";

/**
 * Login hands off to the backend, which redirects to Auth0 and comes back having
 * set the session cookie. The token never touches the browser: an HttpOnly cookie
 * is not readable by injected script, whereas a token in localStorage is, and this
 * is the console for the company's identity data.
 *
 * With AUTH_DEV_BYPASS on, this screen is never reached: the middleware injects a
 * session and the viewer query succeeds. It answers with a 503 page rather than a
 * redirect when no Auth0 configuration is present, so a misconfigured environment
 * says so instead of sending the browser nowhere.
 */
export function Login() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-md">
        <Card title="Partner database / On-demand contractor database">
          <p className="text-sm text-slate-700">
            Sign in with your Need Google account to continue.
          </p>
          <Button
            className="mt-4 w-full justify-center"
            onClick={() => {
              // Full navigation rather than fetch: this is an OAuth redirect, and
              // the cookie has to be set on a top-level response.
              window.location.href = "/auth/login";
            }}
          >
            Sign in
          </Button>
          <p className="mt-4 text-xs text-slate-500">
            Access is granted per person in this console, not in Auth0 — so every grant and
            revocation is recorded. If you have not been granted access, an iam-admin has to add
            you.
          </p>
        </Card>
      </div>
    </div>
  );
}
